var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00029 4.75C5.76039 4.75 4.75018 5.76016 4.75018 7C4.75018 8.23984 5.76039 9.25 7.00029 9.25C8.2402 9.25 9.2504 8.23984 9.2504 7C9.2504 5.76016 8.2402 4.75 7.00029 4.75ZM12.7756 6.63672L10.5559 5.52812L11.3411 3.175C11.4466 2.85625 11.1442 2.55391 10.8278 2.66172L8.47458 3.44688L7.36359 1.225C7.21358 0.925 6.787 0.925 6.63699 1.225L5.52834 3.44453L3.17276 2.65938C2.854 2.55391 2.55164 2.85625 2.65946 3.17266L3.44465 5.52578L1.22501 6.63672C0.924996 6.78672 0.924996 7.21328 1.22501 7.36328L3.44465 8.47187L2.65946 10.8273C2.55398 11.1461 2.85634 11.4484 3.17276 11.3406L5.526 10.5555L6.63465 12.775C6.78466 13.075 7.21124 13.075 7.36125 12.775L8.46989 10.5555L10.8231 11.3406C11.1419 11.4461 11.4443 11.1437 11.3364 10.8273L10.5512 8.47422L12.7709 7.36562C13.0756 7.21328 13.0756 6.78672 12.7756 6.63672ZM9.12149 9.12109C7.9519 10.2906 6.04868 10.2906 4.87909 9.12109C3.70951 7.95156 3.70951 6.04844 4.87909 4.87891C6.04868 3.70937 7.9519 3.70937 9.12149 4.87891C10.2911 6.04844 10.2911 7.95156 9.12149 9.12109Z",
    stroke: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.f5337f8b.svg";
export { ForwardRef as ReactComponent };